import { QBankStructureLevelCategory } from '@exam-management/graphql';
import kebabCase from 'lodash/kebabCase';
import upperFirst from 'lodash/upperFirst';

const QBankStructureLevelLabel = {
  [QBankStructureLevelCategory.Course]: 'คลังข้อสอบ',
  [QBankStructureLevelCategory.Part]: 'หมวด',
  [QBankStructureLevelCategory.Subject]: 'เล่ม/วิชา',
  [QBankStructureLevelCategory.Group]: 'ส่วนที่',
  [QBankStructureLevelCategory.Chapter]: 'บท',
  [QBankStructureLevelCategory.Topic]: 'หัวข้อ',
  [QBankStructureLevelCategory.SubTopic]: 'หัวข้อย่อย',
};

export function getQBankStructureLevelLabelByCategory(
  category: QBankStructureLevelCategory,
  options: {
    withEng?: boolean;
  } = {},
) {
  const { withEng = false } = options;

  if (withEng) {
    return `${QBankStructureLevelLabel[category]} (${upperFirst(kebabCase(category))})`;
  } else {
    return QBankStructureLevelLabel[category];
  }
}
